<template>
  <div
    :class="{
      [$style.LayoutPreview]: true,
      [$style[`LayoutPreview--${theme}`]]: true,
      [$style['LayoutPreview--active']]: active,
    }"
    @click="$emit('onChange', layout)"
  >
    <svg
      v-if="layout === LAYOUT_ENUM.STANDARD"
      width="88"
      height="50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        width="88"
        height="50"
        rx="2"
        fill="currentColor" />
      <path fill="#59B141" d="M35 40h13v4H35z" />
      <path fill="#FA672D" d="M50 40h13v4H50z" />
      <g opacity=".4">
        <path fill="#FA672D" d="M11 7h7v2h-7zM8 10h10v2H8zM6 13h12v2H6zM14 16h4v2h-4zM11 19h7v2h-7zM16 22h2v2h-2z" />
        <path fill="#59B141" d="M6 25h12v2H6zM9 28h9v2H9zM14 31h4v2h-4zM11 34h7v2h-7zM16 37h2v2h-2zM8 40h10v2H8z" />
      </g>
    </svg>

    <svg
      v-if="layout === LAYOUT_ENUM.ADVANCED"
      width="88"
      height="50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        width="88"
        height="50"
        rx="2"
        fill="currentColor" />
      <path fill="#59B141" d="M71 24h13v4H71z" />
      <g opacity=".4">
        <path fill="#FA672D" d="M60 7h7v2h-7zM57 10h10v2H57zM55 13h12v2H55zM63 16h4v2h-4zM60 19h7v2h-7zM65 22h2v2h-2z" />
        <path fill="#59B141" d="M55 25h12v2H55zM58 28h9v2h-9zM63 31h4v2h-4zM60 34h7v2h-7zM65 37h2v2h-2zM57 40h10v2H57z" />
      </g>
    </svg>

    <svg
      v-if="layout === LAYOUT_ENUM.FULLSCREEN"
      width="88"
      height="50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        width="88"
        height="50"
        rx="2"
        fill="currentColor" />
      <path fill="#59B141" d="M57 41h13v3H57z" />
      <path fill="#FA672D" d="M72 41h13v3H72z" />
      <g opacity=".4">
        <path fill="#FA672D" d="M62.417 7H70v2h-7.583zM59.167 10H70v2H59.167zM57 13h13v2H57zM65.667 16H70v2h-4.333zM62.417 19H70v2h-7.583z" />
        <path fill="#59B141" d="M57 22h13v2H57zM60.25 25H70v2h-9.75zM65.667 28H70v2h-4.333zM62.417 31H70v2h-7.583zM67.833 34H70v2h-2.167z" />
      </g>
    </svg>
    <p :class="$style['LayoutPreview--Label']">{{$t(label)}}</p>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { themeProp } from '../../../helper/props';
import { LAYOUT_ENUM } from '../config';

export default defineComponent({
  emits: ['onChange'],
  props: {
    theme: themeProp,
    layout: {
      validator (value) {
        return value === LAYOUT_ENUM.ADVANCED || value === LAYOUT_ENUM.FULLSCREEN || value === LAYOUT_ENUM.STANDARD;
      },
      default: LAYOUT_ENUM.ADVANCED,
    },
    active: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  setup (props) {
    const themeColor = computed(() => props.theme === 'dark' ? '#1A1B1F' : '#fff');
    return {
      themeColor,
      LAYOUT_ENUM,
    };
  },
});
</script>

<style lang="less" module>
.LayoutPreview {
  display: flex;
  flex-direction: column;
  // height: 50px;
  border-radius: 2px;
  align-items: center;
  cursor: pointer;
  color: var(--LayoutPreview-text);
  overflow: hidden;

  &--dark {
    --LayoutPreview-background: #404248;
    --LayoutPreview-text-active: #fff;
    --LayoutPreview-text: #A3A8B7;
    --LayoutPreview-fill: #1A1B1F;
  }
  &--light {
    --LayoutPreview-background: #EFF4F6;
    --LayoutPreview-text-active: #1A1B1F;
    --LayoutPreview-text: #91A5B1;
    --LayoutPreview-fill: #fff;
  }
  svg {
    padding: 10px;
    background-color: var(--LayoutPreview-background);
    rect {
      color: var(--LayoutPreview-fill);
    }
  }
  &--active {
    color: var(--LayoutPreview-text-active);
    svg {
      border: 1px solid #13c2c2;
    }
  }
  &--Label {
    margin-top: 12px;
    font-size: 12px;
  }
}
</style>

